import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";
import { queryClient } from "@/lib/queryClient";
import { router } from "@/router";
import { AuthProvider } from "@/lib/auth";
import { AuthGate } from "@/components/auth/AuthGate";
import { DialogsProvider } from "@/components/ui/confirm";
import { initSentry, SentryErrorBoundary } from "@/lib/sentry";
import { ErrorFallback } from "@/components/ErrorFallback";
import "@/styles/index.css";

// Initialize Sentry before anything else mounts so import-time errors
// in router/page modules are caught. No-ops when VITE_SENTRY_DSN is
// unset, so local dev keeps working.
initSentry();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <SentryErrorBoundary fallback={({ resetError }) => <ErrorFallback resetError={resetError} />}>
      <AuthProvider>
        <AuthGate>
          <QueryClientProvider client={queryClient}>
            <DialogsProvider>
              <RouterProvider router={router} />
            </DialogsProvider>
            <Toaster position="top-right" richColors closeButton />
          </QueryClientProvider>
        </AuthGate>
      </AuthProvider>
    </SentryErrorBoundary>
  </React.StrictMode>,
);
